import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Container, Grid, Typography,
} from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { LoggedInUser } from '../../../types/auth.types';
import Anchor from '../foundation/Anchor';
import { BGContainer, WhiteBGContainer } from '../foundation/Containers';
import CustomBR from '../foundation/CustomBR';
import Page from '../layout/base.page';
import TextArea from '../foundation/TextArea';
import Button from '../foundation/Button';
import { CandidateRecord, searchCandidatesAI } from '../../api/searchCandidates.api';
import SimilarityGauge from '../components/SimilarityGauge';
import { Flexbox } from '../foundation/Flex';

export type AISearchCandidatesProps = {
    url: string
    title: string
    user?: LoggedInUser
    candidates?: CandidateRecord[]
}

type IFormPostJob = {
    description: string
}

const AISearchCandidates = (props: AISearchCandidatesProps): JSX.Element => {
    const [candidates, setCandidates] = React.useState<CandidateRecord[]>(props.candidates || []);

    const {
        register, handleSubmit, formState: { errors }, watch, setValue,
    } = useForm<IFormPostJob>({
        defaultValues: {

        },
    });

    const onSubmit = async (data: IFormPostJob) => {
        const res = await searchCandidatesAI({
            jobDescription: data.description,
        });

        if (res) {
            setCandidates(res.data.candidates);
        }
    };

    const descriptionInput = register('description', { required: true, minLength: 10, maxLength: 2500 });

    const renderKeyValue = (key, value) => {
        if (value && value !== '') {
            return <Typography><b>{key} : </b>{value}</Typography>;
        }
        return '';
    };

    return <Page
        showBreadCrumbs
        url={props.url}
        user={props.user}
        pageHeaderTitle={`Mploy - ${props.title}`} >
        <Container>
            <CustomBR />
            <BGContainer>
                <Typography color="secondary" fontWeight="bold" variant="h4">{props.title}</Typography>
                <CustomBR />
                <CustomBR />
                <Box>
                    <Typography>הזן את תיאור המשרה</Typography>
                    <CustomBR />
                    <TextArea
                        // defaultValue={props.job?.description}
                        {...descriptionInput}
                        inputRef={descriptionInput.ref}
                        required
                        // onBlur={() => {}}
                        label="תיאור המשרה"
                        name="description"
                        id="description"
                        helperText={errors.description && 'יש להזין תיאור משרה בין 10 ל 2500 תווים.'}
                        fullWidth
                        rows={5}
                        maxLength={2500}
                    />
                </Box>
                <CustomBR />

                <Button size="large" onClick={handleSubmit(onSubmit)} color="primary" fullWidth>
                    הצג מועמדים רלוונטים
                </Button>
            </BGContainer>

            <CustomBR />
            {candidates?.length ? <WhiteBGContainer>
                <Typography color="secondary" fontWeight="bold" variant="h4">מועמדים רלוונטים</Typography>
                <CustomBR />
                <CustomBR />
                {candidates.map(candidate => (
                    <>
                        <Card>
                            <CardContent>
                                <Flexbox>
                                    <Box>
                                        {renderKeyValue('שם פרטי', candidate.firstName)}
                                        {renderKeyValue('מיקומים רלוונטים', candidate.locations.join(', '))}
                                        {renderKeyValue('פעילות אחרונה', new Date(candidate.lastActivity).toLocaleDateString('he-IL'))}
                                        {renderKeyValue('תקציר קורות חיים', candidate.cvSummary)}
                                        <CustomBR />
                                        <Anchor blank href={`/anonymous-employer-view/watchcv/${candidate.userId}/cv/${candidate.cvId}`}>
                                        צפייה בקורות חיים
                                        </Anchor>
                                    </Box>
                                    <Box width={80} minWidth="100px" marginLeft="auto">
                                        <SimilarityGauge
                                            similarity={candidate.similarity}
                                            size="medium"
                                        />
                                    </Box>
                                </Flexbox>
                            </CardContent>
                        </Card>
                        <CustomBR />
                    </>
                ))}
            </WhiteBGContainer> : ''}
        </Container>
        <CustomBR />
    </Page>;
};
export default AISearchCandidates;
